import { useLatestValueRef } from '@surveycake/rhooks';
import { throttle } from '@surveycake/utils';
import { GoPageAndSubmitDisabledService } from 'app/modules/survey';
import { useMemo } from 'react';

export function useOnSubmit(callback: () => void) {
  const disabled = GoPageAndSubmitDisabledService.useDisabled();
  /**
   * To avoid from onSubmit depending on disabled.
   */
  const disabledRef = useLatestValueRef(disabled);
  /**
   * @todo Add `useThrottle` to @surveycake/rhooks
   */
  const onSubmit = useMemo(
    () =>
      throttle(2000)(() => {
        if (disabledRef.current) {
          return;
        }

        callback();
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback]
  );

  return { disabled, onSubmit };
}
